export const GET_INDUSTRY = "GET_INDUSTRY";
export const GET_DEPARTMENT = "GET_DEPARTMENT";
export const GET_POSITION = "GET_POSITION";
export const SALARY_DATA = "SALARY_DATA";

export const DELETE_DATA = "DELETE_DATA";


// WEBPACK FOOTER //
// ./src/constants/salaryReport.js